import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AssistedBookingStatusModal from 'components/AssistedBookingStatus/AssistedBookingStatusModal';

import { toggleModal } from 'actions/modalActions';
import { acknowledgeAssistedBookingNotification } from 'actions/bookActions';

/* istanbul ignore next */
const mapStateToProps = state => ({
  bookState: state.bookState,
  backUrl: state.bookState.getIn(['data', 'availability_url']),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  toggleModalBound: bindActionCreators(toggleModal, dispatch),
  acknowledgeAssistedBookingNotificationBound: bindActionCreators(acknowledgeAssistedBookingNotification, dispatch),
});

export class AssistedBookingStatusLayout extends Component {
  static propTypes = {
    bookState: ImmutablePropTypes.map.isRequired,
    toggleModalBound: PropTypes.func.isRequired,
    acknowledgeAssistedBookingNotificationBound: PropTypes.func.isRequired,
  };

  onClose = (event) => {
    const { toggleModalBound, acknowledgeAssistedBookingNotificationBound } = this.props;

    event.preventDefault();
    acknowledgeAssistedBookingNotificationBound();
    toggleModalBound();
  };

  onBack = () => {
    const { toggleModalBound } = this.props;
    toggleModalBound();
  };

  render() {
    const {
      bookState,
    } = this.props;

    const bookingComponentStatuses = bookState.getIn(['data', 'booking_component_statuses']);
    const backUrl = bookState.getIn(['data', 'availability_url']);

    return (
      <AssistedBookingStatusModal
        bookingComponentStatuses={bookingComponentStatuses}
        backUrl={backUrl}
        onBack={this.onBack}
        onClose={this.onClose}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssistedBookingStatusLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/AssistedBookingStatusLayout/AssistedBookingStatusLayout.jsx
 **/